import React from "react";
import { Link } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";

const PrimaryButton = ({
  to,
  href,
  onClick,
  children,
  variant = "primary",
  pulse = false,
  type = "button",
  className = "",
}) => {
  const reduce = useReducedMotion();
  const classes = [
    "sv-btn",
    `sv-btn--${variant}`,
    pulse ? "sv-btn--pulse" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const motionProps = reduce
    ? {}
    : {
        whileHover: { y: -2 },
        whileTap: { scale: 0.98, y: 0 },
        transition: { duration: 0.18, ease: [0.22, 1, 0.36, 1] },
      };

  if (to) {
    return (
      <motion.div style={{ display: "inline-flex" }} {...motionProps}>
        <Link
          to={to}
          className={classes}
          onClick={(e) => {
            window.scrollTo({ top: 0, left: 0, behavior: "instant" });
            onClick?.(e);
          }}
        >
          {children}
        </Link>
      </motion.div>
    );
  }

  if (href) {
    return (
      <motion.div style={{ display: "inline-flex" }} {...motionProps}>
        <a href={href} className={classes} onClick={onClick}>
          {children}
        </a>
      </motion.div>
    );
  }

  return (
    <motion.button
      type={type}
      className={classes}
      onClick={onClick}
      {...motionProps}
    >
      {children}
    </motion.button>
  );
};

export default PrimaryButton;
